// angular
import { ActivatedRoute } from '@angular/router';
import { Component, effect, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
// components
import { VideoPlayerComponent } from '@app/core/components/video-player/video-player.component';
import { ButtonComponent } from '@app/core/components/button/button.component';
import { BarcodeDialogComponent } from '@app/core/dialogs/barcode-dialog/barcode-dialog.component';
// services
import { HelpService } from '../shared/services/help.service';
import { DialogService } from '@app/core/shared/services/dialog.service';
// interfaces
import { IHelpData } from '@app/+help/shared/interfaces/help-data.interface';
// pipes
import { TranslateDataPipe } from '@app/shared/pipes/translate-data.pipe';
import { ImageSourcePipe } from '@app/shared/pipes/image-source.pipe';

@Component({
  selector: 'pwj-help-detail',
  standalone: true,
  imports: [
    TranslateDataPipe,
    VideoPlayerComponent,
    ButtonComponent,
    ImageSourcePipe,
    TranslateModule,
  ],
  templateUrl: './help-detail.component.html',
  styleUrl: './help-detail.component.scss',
})
export class HelpDetailComponent {
  public pageLink!: string;

  public helpDetailsData!: IHelpData;
  public isHelpDetailsLoading!: boolean;

  // dependencies
  private readonly _helpService = inject(HelpService);
  private readonly _activatedRoute = inject(ActivatedRoute);
  private readonly _dialogService = inject(DialogService);

  constructor() {
    // set auction id
    this._activatedRoute.params.subscribe(params => {
      this._helpService.helpDetails.set(null);
      // get help id
      const helpId = params?.['helpId'];
      // fetch help details data
      if (helpId) {
        this._helpService.getHelpDetailsData(helpId);
      }
    });

    // set help details data
    effect(() => {
      if (this._helpService.helpDetails() !== null) {
        this.helpDetailsData = this._helpService.helpDetails() as IHelpData;
      }
    });

    // set page link
    this.pageLink = window.location.href;
  }

  // share with qr-code functionality
  public openQrCodeDialog(barcodeContent: string) {
    this._dialogService.open(BarcodeDialogComponent, {
      width: 'none',
      height: 'none',
      data: {
        title: 'products.qrCode',
        productTitle: this.helpDetailsData?.topic?.title,
        productCode: this.helpDetailsData?.topic?.code,
        barcodeContent,
      },
    });
  }
}
